
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0v18.03L4.4 21l5.596-2.545 5.281 2.54L20 18.275V.012l-4.675 2.492L9.885.209 4.488 2.501 0 0zm9.887.958l5.47 2.308 3.961-2.11v16.718l-4.07 2.343-5.244-2.522-5.54 2.519L.683 17.66V1.168l3.765 2.1 5.44-2.31z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M4.5 20V3v17z"}}),_c('path',{attrs:{"d":"M5 20.364V3H4v17.364z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M9.5 18V1v17z"}}),_c('path',{attrs:{"d":"M9.5 18h1V.636h-1z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M14.5 20V3v17z"}}),_c('path',{attrs:{"d":"M15.789 2.697h-1v17.576h1z"}})])
          )
        }
      }
    